import "./sidebar.css";
import React, { useEffect, useState } from "react";
import { NavLink, useHistory } from "react-router-dom";
import api from "../../seller-apis/api";
import { useDispatch, useSelector } from "react-redux";
import { Popover, OverlayTrigger } from "react-bootstrap";
import { fetchOpportunityData, meOnly } from '../../seller-apis/apidataField'
import { Actions } from "../../Actions/Actions";
import { unregisterDeviceToken } from "../../services/push.service";

const Sidebar = () => {
  const { sellerPic, sellerMeData } = useSelector((state) => state.vendorDetailsReducer);
  const [openSubMenu, setOpenSubMenu] = useState(null);
  // const [ordersCount, setOrdersCount] = useState(null);
  // const [inventoryCount, setInventoryCount] = useState(null);
  // const [RTOOrdersCount, setRTOOrdersCount] = useState(null);
  // const [pendingQuestionCount, setPendingQuestionCount] = useState(null);
  const [sellerDetail, setsellerDetails] = useState("");
  // const [verifiedSeller, setVerifiedSeller] = useState(true);
  // const [pActionRequiredCount, setPActionReqCount] = useState(true);
  // const [leadCount, setLeadCount] = useState(0);
  // const [newOpportunityCount, setNewOpportunityCount] = useState(0);
  // const [grabOrderCount, setGrabOrderCount] = useState(0);//SL-660 Grab Order
  // console.log(stateData);
  const currentUrl = window.location.pathname;
  const {
  ordersCount,
  RTOCount,
  inventoryCount,
  verifiedSeller,
  pActionRequiredCount,
  PendingQuestionCount,
  grabOrderCount,
  pendingNoticeCount,
  TotalLeadCount,
  LeadCount,
  sellerCount,
  ShowHideMenu,
  RTOOrdersCount,
  pendingQuestionCount
} = useSelector(state => state.ActionReducer);

  const history = useHistory();
  useEffect(() => {
    api.auth
      .me(meOnly({
        "excludeField": {
          "name": 1,
          "active": 1,
          "activeState": 1
        }
      }
      ))
      .then((res) => {
        setsellerDetails(res.data);
        // if (res.message === "Seller Not Activated") {
        //   setisVerifiedSeller(false);
        // }
      })
      .catch((err) => console.log(err));

  }, []);




  async function logout() {
    try{
      await unregisterDeviceToken()
    }catch(err){
      console.warn("Error during unregisterDeviceToken on logout:", err);
    }finally{
      localStorage.clear();
      window.location.assign("/");
    }
  }
  const toggleSubMenu = (menuIndex) => {
    if (openSubMenu === menuIndex) {
      setOpenSubMenu(null);
    }
    else {
      setOpenSubMenu(menuIndex);

    }
  };
  //<Start-Here> Ticket: SL-693
  //Need to disable the "customer reviews" tab for those seller who are not active yet 
  const mIsActiveState = typeof sellerDetail.activeState != 'undefined' && sellerDetail.activeState === "Active" ? true : false;

  const topMenus = [
    {
      label: "Notices",
      link: "/brand-notice",
      icon: "add-bell.png",
      show: sellerDetail?.activeState === "partialInactive" || !verifiedSeller ? false : true,
      new: false,
      countShow: pendingNoticeCount,
      subMenus: [],
    },
    {
      label: "Support",
      link: "/seller-support",
      icon: "support.webp",
      show: true,
      new: false,
      subMenus: [],
    },
  ]

  const menus = [
    {
      label: "Home",
      link: "/home",
      icon: "home.webp",
      show: true,
      new: false,
      subMenus: [],
      new: false,
    },
    {
      label: "Brands",
      icon: "brand.webp",
      link: "/my-brands",
      show: sellerDetail?.activeState === "partialInactive" || !verifiedSeller ? false : true,
      new: false,
      subMenus: [],
      subMenus: [
        { label: "My Brands", link: "/my-brands", show: true, },
        {
          label: "Add New Brand",
          link: "/apply-brand",
          show: true,
        },
        {
          label: "Transactions",
          link: "/brand/transaction",
          show: true,
        }
      ],
    },
    {
      label: "Opportunities",
      icon: "payment.webp",
      link: "/opportunities/product-opportunities",
      show: sellerDetail?.activeState === "partialInactive" || !verifiedSeller ? false : true,
      new: false,
      subMenus: [
        { label: "Product opportunities", link: "/opportunities/product-opportunities", show: true, },
        { label: "Re-stock opportunities", link: "/opportunities/outofstock-opportunities", show: true, },
        { label: "Pricing opportunities", link: "/opportunities/pricing-opportunities", show: true, }
      ],
    },
    {
      label: "Enquiries",
      link: "/my-enquiry",
      icon: "enquiry.webp",
      show: sellerDetail?.activeState === "partialInactive" || !verifiedSeller ? false : true,
      new: false,
      subMenus: [],
      new: false,
    },
    {
      label: "Add New Product",
      link: "/products",
      icon: "order.webp",
      show: sellerDetail?.activeState === "partialInactive" ? false : true,
      new: false,
      countShow: pActionRequiredCount,
      subMenus: [
        { label: "Simple Product", link: "/add-product1", show: true, },
        { label: "Bulk Upload", link: "/bulk-upload", show: true, },
        { label: "Choose from Catalogue", link: "/add-Product", show: true, },
        { label: "Drafts", link: "/my-inventory/new_product_request/drafted", show: true, },
        { label: "Action Required", link: "/my-inventory/new_product_request/action_req", show: true, count: pActionRequiredCount }
      ],
    },
    //<Start-Here> Leads Ticket: SL-710
    {
      label: "Leads",
      icon: "question.webp",
      show: sellerDetail?.activeState !== "partialInactive" && TotalLeadCount ? true : false,
      link: "/customer-leads/details",//"/leads",
      countShow: LeadCount,
      new: false,
      subMenus: [
        /*{ label: "New Leads", link: "/locked-leads", show: true, },
        { label: "Purchased Leads", link: "/customer-leads/details", show: true, },*/
      ],
    },
    //</End-Here> Leads Ticket: SL-710
    {
      label: "Orders",
      link: "/my-order/unprocessed",
      icon: "order.webp",
      show: !verifiedSeller ? false : true,
      new: false,
      countShow: ordersCount?.newOrders,
      subMenus: [
        { label: "Grab order", link: "/my-order/graborder", count: grabOrderCount, show: grabOrderCount > 0 ? true : false, },
        {label : "Product Opportunities", link: "/my-order/product-opportunities", count: ordersCount?.ProductOpportunities, show: ordersCount?.ProductOpportunities > 0 ? true : false},
        { label: "New orders", link: "/my-order/unprocessed", count: ordersCount?.newOrders, show: true, },
        {label: 'Request for Pickup', link: "/my-order/pickup-request", count: ordersCount?.pickupRequest, show: ordersCount?.pickupRequest > 0 ? true : false},
        {
          label: "Support Redispatch",
          link: "/my-order/redispatch",
          count: ordersCount?.Redispatch,
          show: true,
        },        
        {
          label: "Support Reverse",
          link: "/my-order/reverse",
          count: ordersCount?.reverseOrder,
          show: true,
        },
        { label: "Ready to Ship", link: "/my-order/processed", count: ordersCount?.readyToShipped, show: true, },
        { label: "Shipped", link: "/my-order/inTransit", show: true, },
        { label: "Cancelled", link: "/my-order/cancelled", show: true, },
        { label: "Revoked", link: "/my-order/revoke",count:ordersCount?.revoked, show: true, },
        { label: "Delivered", link: "/my-order/delivered", show: true, },
        { label: "All Orders", link: "/my-order/allOrders", show: true, },
      ],
    },
    {
      label: "Returns",
      link: "/my-order/rto/in_transit",
      icon: "rto.webp",
      show: !verifiedSeller ? false : true,
      new: false,
      subMenus: [
        { label: "In-Transit", link: "/my-order/rto/in_transit", count: RTOCount?.intransit, show: true, },
        { label: "Delivered", link: "/my-order/rto/delivered", show: true },
      ],
    },
    {
      label: "Products",
      icon: "inventory.webp",
      link: "/my-inventory/approved/all-products",
      show: sellerDetail?.activeState === "partialInactive" ? false : true,
      new: false,
      showBadge: true,
      subMenus: [
        { label: "All Products", link: "/my-inventory/approved/all-products", count: inventoryCount?.allProducts, show: true, },
        { label: "Active Products", link: "/my-inventory/approved/active", count: inventoryCount?.activeProducts, show: true, },
        {
          label: "Out of Stock",
          link: "/my-inventory/approved/outofstock",
          count: inventoryCount?.outofstock,
          show: true,
        },
        {
          label: "Transfer price Change Requests",
          link: "/my-inventory/approved/actionrequired",
          count: inventoryCount?.actionRequired,
          show: inventoryCount?.actionRequired > 0 ? true : false,
        },
        {
          label: "Weight Verification",
          link: "/my-inventory/approved/weightverification",
          count: inventoryCount?.weightVerification,
          show: inventoryCount?.weightVerification > 0 ? true : false,
        },
        {
          label: "Blocked Products",
          link: "/my-inventory/approved/blocked",
          count: inventoryCount?.blockedProducts,
          // Only show if there are blocked products
          show: inventoryCount?.blockedProducts > 0,
        },
      ],
    },
    //<Start-Here> Ticket: SL-693
    {
      label: "Reviews",
      icon: "brand.webp",
      link: "/customerReviews",
      show: mIsActiveState,//sellerDetail?.activeState === "partialInactive" ? false : true,
      // count:stateData.ActionReducer.sellerCount,
      new: false,
      subMenus: [],
    },
    //</End-Here> Ticket: SL-693
    // {
    //   label: "Customer Support",
    //   icon: "brand.webp",
    //   link: "/support",
    //   show: !verifiedSeller ? false : true,
    //   count: stateData.ActionReducer.sellerCount,
    //   new: false,
    //   subMenus: [],
    // },
    {
      label: "Customer Support",
      icon: "brand.webp",
      link: "/support",
      show: !verifiedSeller ? false : true,
      // count: sellerCount,
      new: false,
      subMenus: [],
    },
    // {
    //   label: "Pricing",
    //   icon: "brand.webp",
    //   link: "/pricing",
    //   show: !verifiedSeller ? false : true,
    //   // count:stateData.ActionReducer.sellerCount,
    //   new: false,
    //   subMenus: [],
    // },
    {
      label: "Q & A",
      icon: "question.webp",
      show: sellerDetail?.activeState === "partialInactive" || !verifiedSeller ? false : true,
      link: "/questions/pending",
      new: false,
      // count: PendingQuestionCount,
      subMenus: [],
    },
    // {
    //   label: "Purchase Request",
    //   icon: "support.webp",
    //   link: "/purchaseReq",
    //   show: sellerDetail?.activeState !== "partialInactive" && localStorage.getItem("vendorType") === "In-House" ? true : false,
    //   new: false,
    //   subMenus: [],
    //   new: false,
    // },
    {
      label: "Report",
      icon: "report.webp",
      link: "/payment/my-transactions",
      show: !verifiedSeller ? false : true,
      new: false,
      subMenus: [
        { label: "Orders", link: "/payment/my-transactions", show: true, },
        { label: "Leads", link: "/wallet-transaction", show: true, },
      ],
    },
    {
      label: "Payment",
      icon: "payment.webp",
      link: "/payment/settlements/completed",
      show: !verifiedSeller ? false : true,
      new: false,
      subMenus: [
        { label: "Completed", link: "/payment/settlements/completed", show: true, },
        { label: "Onhold", link: "/payment/settlements/onhold", show: true, },
        { label: "Deduction", link: "/payment/settlements/deduction", show: true, },
        { label: "Penalty", link: "/payment/settlements/penalty", show: true, }
      ],
    },
  /*{
      label: "FAQ's",
      icon: "faq.webp",
      link: "/faq/faq-tcs",
      show: true,
      new: false,
      subMenus: [
        { label: "FAQ's for TCS", link: "/faq/faq-tcs", show: true, },
        {
          label: "FAQ's for TDS",
          link: "/faq/faq-tds",
          show: true,
        },
        {
          label: "FAQ for Form 16A",
          link: "/faq/faq-form16",
          show: true,
        },
      ],
    },*/
    {
      label: "FAQ's",
      icon: "faq.webp",
      link: "/faq-list",
      show: true,
      new: false,
      subMenus: [],
    },
 


    // Add more menu objects as needed
  ];
  //</End-Here> Ticket: SL-693

  // console .log(menus)
  useEffect(() => {
    let submenuExist = 0;
    let splitedPath = currentUrl.split('/');
    menus.forEach((element, index) => {
      currentUrl == element.link && setOpenSubMenu(element.label + index);
      if (element.subMenus.length > 0) {
        element.subMenus.forEach(element1 => {

          if (currentUrl == element1.link) {
            submenuExist++;
            setOpenSubMenu(element.label + index);
          }
          if (!submenuExist) {
            if (element1.link.includes(splitedPath[1])) {
              submenuExist++;
              setOpenSubMenu(element.label + index);
            }
          }

        })
      }
    });
  }, [currentUrl])
  const dispatch = useDispatch();
  function toggleSidebar(data) {
    Actions.toggleSideBar(dispatch, data);
  }
  return (
    <>
      <div className={`back-drob  ${!ShowHideMenu ? "d-none d-lg-block" : ""}`} style={{ position: "fixed" }} onClick={() => toggleSidebar(false)}>
        <div className="cross-menu" onClick={() => toggleSidebar(false)}>x</div>
      </div>
      <div className={`sidebar ${!ShowHideMenu ? "d-none d-lg-block" : ""}`}>
        <ul className="user-profile">
          <li>
            {/* <img
        src="/menu-icon/seller-logo.webp"
        alt="LOGO"
        className="sidebar-logo img-fluid"
      /> */}
            {/* {sellerPic == "" ? (
        <div className="icon">
          {sellerDetail?.name && sellerDetail?.name[0]}
        </div>
      ) : (
        <div className="profile-pic">
          <img
            src={
              "https://s3.toolsvilla.com/mob/avatar/" +
              sellerPic
            }
            className="top-logo h-75 me-2"
            alt="user"
          ></img>
        </div>
      )} */}

            <OverlayTrigger
              trigger="click"
              key="profile"
              rootClose
              placement="right"
              overlay={<Popover id="profile">
                <Popover.Body className="header_popover">
                  <div className="sidebar-popup-menu"><a href="/profile">
                    <button><img src="/menu-icon/popup/profile.png" class="sidebar-popup-menu-icon" alt="icon" /> Profile</button>
                  </a></div>
                  <div className="sidebar-popup-menu"><button onClick={() => logout()}>
                    <img src="/menu-icon/popup/logout.png" class="sidebar-popup-menu-icon" alt="icon" /> Log-out
                  </button></div>
                </Popover.Body>
              </Popover>}
            >
              <button>
                {sellerPic == "" ? (
                  <div className="icon">
                    {sellerDetail?.name && sellerDetail?.name[0]}
                  </div>
                ) : (
                  <div className="profile-pic">
                    <img
                      src={"https://s3.toolsvilla.com/mob/avatar/" +
                        sellerPic}
                      className="top-logo h-75 me-2"
                      alt="user"
                    ></img>
                  </div>
                )}
                <div className="text-left user-name">{sellerDetail?.name}</div> <i class="bi bi-chevron-right"></i>
              </button>
            </OverlayTrigger> 
          </li>
        </ul>
        <div className="main-menu">
          <ul className="nav flex-column">
            <>
            <div className="d-flex" style={{width:"100%"}}>
              {
                topMenus.map((menu, index) => (
                  menu.show && <li
                  className={`nav-item border-bottom flex-fill ${openSubMenu === menu.label + index ? "active" : ""}`}
                  key={index}
                  >
                  <NavLink
                    to={menu.link}
                    key={index}
                    onClick={() => toggleSubMenu(menu.label + index)}
                    className={`nav-link ${openSubMenu === menu.label + index ? "active" : ""}`}
                    style={{ cursor: "pointer" }}
                  >
                    <img
                      src={"/menu-icon/" + menu.icon}
                      className="menu-icon"
                      alt="icon" />{" "}
                    {menu.new ? <img src="/new-button.gif" className="new-menu" /> : ""}
                    <div className="main-menu-label">{menu.label}{" "}</div>
                    {menu?.hasOwnProperty('countShow') ? (
                          <>
                            {menu?.countShow === undefined ? (
                              <div className="custom-loader"></div>
                            ) : (
                              Number(menu?.countShow) > 0 ? (
                                <div className="menu-count">{menu?.countShow}</div>
                              ) : null
                            )}
                          </>
                        ) : null}

                  </NavLink>
                  </li>
                ))
            }
            </div>

            {menus.map((menu, index = index + 2) => (
              menu.show && <li
                className={`nav-item border-bottom ${openSubMenu === menu.label + index ? "active" : ""}`}
                key={index}
              >
                {menu.subMenus.length == 0 ? (
                  <NavLink
                    to={menu.link}
                    onClick={() => toggleSubMenu(menu.label + index)}
                    className={`nav-link ${openSubMenu === menu.label + index ? "active" : ""}`}
                    style={{ cursor: "pointer" }}
                  >
                    <img
                      src={"/menu-icon/" + menu.icon}
                      className="menu-icon"
                      alt="icon" />{" "}
                    {menu.new ? <img src="/new-button.gif" className="new-menu" /> : ""}
                    <div className="main-menu-label">{menu.label}{" "}</div>
                    {menu.hasOwnProperty('count') ?
                      <>
                        {
                          // menu.hasOwnProperty('count') ? (menu?.count !== null && menu.count > 0 ? `(${menu?.count})` : null) : <div className="custom-loader"></div>
                          menu?.count == undefined ? <div className="custom-loader"></div> : menu?.count !== null && menu?.count > 0 ? `(${menu?.count})` : null}</> : ""}
                    {menu.subMenus.length > 0 && (
                      <img
                        src={"/menu-icon/right-arrow.png"}
                        className={`right-menu-icon  ${openSubMenu == menu.label + index ? "rotate-icon" : ""}`} />
                    )}
                  </NavLink>
                ) : (
                  <NavLink
                    aria-current="page"
                    to={menu.link}
                    onClick={() => toggleSubMenu(menu.label + index)}
                    className={`nav-link ${openSubMenu === menu.label + index ? "active" : ""}`}
                    style={{ cursor: "pointer" }}
                  >
                    <img
                      src={"/menu-icon/" + menu.icon}
                      class="menu-icon"
                      alt="icon" />{menu.new ? <img src="/new-button.gif" className="new-menu" /> : ""}
                    <div className="main-menu-label">
                      {menu.label}{" "}
                      <div className="badge-container">
                        {/* {menu.hasOwnProperty('showBadge') && menu.showBadge ?<div className="menu-badge">Out Of Stock <strong>(10)</strong></div>:""} */}
                        {/* {menu.hasOwnProperty('countShow') ? menu?.countShow!=null  && menu?.countShow>0 ? <div className="menu-count">{menu?.countShow}</div> : <div className="custom-loader"></div>:''} */}
                        {menu.hasOwnProperty('countShow') ?
                          <>
                            {menu?.countShow === undefined ? <div className="custom-loader"></div> : menu?.countShow !== null && menu?.countShow > 0 ? <div className="menu-count">{menu?.countShow}</div> : null}
                          </> : ""}
                        <img
                          src="/menu-icon/right-arrow.png"
                          class={`right-menu-icon  ${openSubMenu == menu.label + index ? "rotate-icon" : ""}`} />
                      </div>
                    </div>
                  </NavLink>
                )}
                <ul
                  className={`nav flex-column submenu ${openSubMenu === menu.label + index ? "show" : ""}`}
                >
                  {menu.subMenus.map((subMenu, subIndex) => (
                    subMenu.show && <li className="nav-item" key={subIndex}>
                      <NavLink className={`nav-link submenu-item space-between ${subMenu.hasOwnProperty('count') ? subMenu.color : ""}`} to={subMenu.link}>
                     
                        <div className="main-menu-label">{subMenu.label}</div>
                        {/* {subMenu.hasOwnProperty('count') ? subMenu?.count!=null && subMenu?.count>0 ? <div className={`menu-count ${subMenu.hasOwnProperty('count') ? subMenu.color : ""}`} style={{color:'#6D6D6D'}}>{subMenu?.count}</div> : <div className="custom-loader"></div>:''} */}
                        {subMenu.hasOwnProperty('count') ?
                          <>
                            {subMenu?.count === undefined ? <div className="custom-loader"></div> : subMenu?.count !== null && subMenu?.count > 0 ? <div className={`menu-count ${subMenu.hasOwnProperty('count') ? subMenu.color : ""}`} style={{ color: '#6D6D6D' }}>{subMenu?.count}</div> : null}
                          </> : ""}
                      </NavLink>
                    </li>
                  ))}
                </ul>
              </li>
            ))}
            </>
          </ul>
        </div>
        <ul className="nav flex-column bottom-menu">
          <li class="nav-item border-bottom ">
            <img
              src="/menu-icon/seller-logo.webp"
              alt="LOGO"
              className="sidebar-logo img-fluid" />
            {/* <a class="nav-link" href="/profile" style={{cursor: 'pointer'}}>
        <img src="/menu-icon/profile.webp" class="menu-icon" alt="icon" />{" "}
        Profile{" "}
      </a>
      <ul class="nav flex-column submenu "></ul> */}
          </li>
          {/* <li class="nav-item border-bottom ">
        <a class="nav-link" href="/-" style={{cursor: 'pointer'}}>
          <img src="/menu-icon/logout.webp" class="menu-icon" alt="icon" />{" "}
          Logout{" "}
        </a>
        <ul class="nav flex-column submenu "></ul>
      </li> */}
        </ul>
      </div>
    </>
  );
};

export default Sidebar;
